import './_snow.scss'
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Snowflakes from './snowflakestest';
import { IS_PROD } from '../../../utils/config';

let snowflakes;

const NewYearPreview = ({ options, isPreview, onChangePreview }) => {
  const node = useRef()
  const nodeNavbar = useRef()

  const [isInit, setInit] = useState(false);

  useEffect(() => {
    if (isInit) {
      snowflakes.destroy()
      /**
       * NewYearEvent подключается файлом отдельно на dev или prod
       */
      if (window?.NewYearEvent && options && isPreview) {
        nodeNavbar.current.innerHTML = ''
        node.current.innerHTML = ''

        const newOptions = {
          snow: {
            ...options.snow,
            options: {
              ...options.snow.options,
              container: node.current,
            },
          },
          fireworks: {
            ...options.fireworks,
            options: {
              ...options.fireworks.options,
              container: node.current,
            },
          },
          garland: {
            ...options.garland,
            options: {
              ...options.garland.options,
              container: nodeNavbar.current,
            },
          },
        }
        if (options.toys.init) {
          if (options.toys?.options?.images?.length) {
            snowflakes = new Snowflakes({
              ...options.toys.options,
              container: node.current,
            });
          }
        }
        const newYearEvent = new window.NewYearEvent(newOptions)
        newYearEvent.start()
      }
    }
  }, [isInit, isPreview, options])

  const appendNewYearLib = () => {
    const eventScript = document.querySelector('script[src="/js/libs/newyearevents.js"]');
    if (!eventScript && IS_PROD) {
      const script = document.createElement('script');
      script.src = '/js/libs/newyearevents.js'
      document.body.appendChild(script);
    }
    return eventScript;
  }

  useEffect(() => {
    snowflakes = new Snowflakes();
    snowflakes.stop();
    appendNewYearLib();
    setTimeout(() => {
      setInit(true);
    }, 1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInit])

  const seePreview = () => {
    onChangePreview()
  }

  return (
    <>
      {!isPreview ? (
        <div className="new-year__preview-empty">
          <button className="btn btn-default" onClick={seePreview}>See preview</button>
        </div>
      ) : null }
      <div className="new-year__preview-container" ref={node} />
      <div className="new-year__fake-navbar" ref={nodeNavbar} />
    </>
  );
};

NewYearPreview.propTypes = {
  options: PropTypes.object,
  isPreview: PropTypes.bool,
  onChangePreview: PropTypes.func,
};
export default NewYearPreview;
